import { render, staticRenderFns } from "./AddProductType.vue?vue&type=template&id=fd8867a8&scoped=true&"
import script from "./AddProductType.vue?vue&type=script&lang=js&"
export * from "./AddProductType.vue?vue&type=script&lang=js&"
import style0 from "./AddProductType.vue?vue&type=style&index=0&id=fd8867a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8867a8",
  null
  
)

export default component.exports